<!-- <div class="m-header__top margintop10">
	<div class="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
		<div class="m-stack m-stack--ver m-stack--desktop">
			<div class="m-stack__item m-brand">
				<div class="m-stack m-stack--ver m-stack--general m-stack--inline">
					<div class="m-stack__item m-stack__item--middle m-brand__logo">
						<a routerLink="/" class="m-brand__logo-wrapper">
							<img class="logo-img" alt="" src="./assets/images/full-banner.png" />
						</a>
					</div>

				</div>
			</div>

		</div>
	</div>
</div>
<div> -->
<div class="container-fluid padBottom3">
	<button class="btn btn-next pull-right marTop2" routerLink="../analytics">Back</button>
</div>
<br>
<div class="col-md-12">
	<form [formGroup]='filterForm'>
		<div class='row'>
			<div class="form-group m-form__control col-3">
				<label>State:</label>
				<div class="input-group">
					<select class="form-control" placeholder="Select State/Union Territory" formControlName="state">
						<option value="" selected>Select State/Union Territory</option>
						<option *ngFor="let stateObj of states" [ngValue]="stateObj.code">{{stateObj.name}}</option>
					</select>
				</div>
			</div>
			<div class="col-2">
				<label>Training Partner Id:</label>
				<div class="input-group">
					<input type="text" class="form-control m-input m-input--solid" placeholder="Search By TP Id"
						formControlName="tpId" />
				</div>
			</div>
			<div class="col-6">
				<app-date-duration label="Duration" [formElement]="durationFields" class="style-null"
					[formValue]="filterForm.get('duration')">
					<app-form-control-messages [control]="filterForm.controls['duration']" [name]="'Duration'">
					</app-form-control-messages>
				</app-date-duration>
			</div>

			<div class='form-group m-form__control col-1'>
				<label></label>
				<div class="input-group">
					<button class='btn btn-next form-control' (click)='apply()'> Apply</button>
				</div>
			</div>
		</div>


	</form>
</div>
<div class="col-md-12">
	<iframe [src]="tcUrl" frameborder="0" style="width: 100%; height: 700px;"></iframe>
</div>

<!-- <section class="footer" id="footer">
		<div class="container">
			<div class="row">
				<div class="col-lg-2 col-md-2">
					<ul class="quick-links">
						<h5 translate>LINKS</h5>
						<li class="links" translate>HOME</li>
						<li class="links">
							<a href="javascript:;" translate>SSC</a>
						</li>
						<li class="links">
							<a href="javascript:;" translate>TRAINING PARTNER & CENTRE</a>
						</li>
					</ul>
				</div>
				<div class="col-lg-2 col-md-2">
					<ul class="quick-links">
						<h5></h5>
						<br>
						<li class="links">
							<a href="javascript:;" translate>DISCLAIMER</a>
						</li>
						<li class="links">
							<a href="javascript:;" translate>PRIVACY_POLICY</a>

						</li>
						<li class="links">
							<a href="javascript:;" translate>TERMS_CONDITIONS</a>

						</li>
						<li class="links">
							<a href="javascript:;" translate>CONTACT_US</a>
						</li>
					</ul>
				</div>
				<div class="col-lg-2 col-md-1">

				</div>
				<div class="col-lg-2 col-md-2">
					<ul class="quick-links">
						<h5 translate>STAY_CONTACT</h5>
						<li class="links social-media">
							<a href="https://www.facebook.com/NSDCIndiaOfficial" target="_blank"  rel="noopener">
								<img src="../../../assets/images/facebook_black.png" alt="">&nbsp;&nbsp;Facebook</a>
						</li>
						<li class="links social-media">
							<a href="https://twitter.com/nsdcindia">
								<img src="../../../assets/images/twitter_black.png" target="_blank"  rel="noopener" alt="">&nbsp;&nbsp;Twitter</a>
						</li>

					</ul>
				</div>
				<div class="col-lg-1 col-md-1">

				</div>
				<div class="col-lg-2 col-md-2">
					<div class="playstore">
						<img src="../../../assets/images/NSDC_Logo.png" alt="">
					</div>
				</div>
			</div>

		</div>
	</section>
	<section class="copyright-footer">
	</section> -->
<!-- </div> -->